// 由 EB view/admin/src/router/modules/delivery.js 自动转换
// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016-2026 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------
import Layout from '@/layout/index.vue';
import type { RouteRecordRaw } from 'vue-router'
import { roterPre } from '@/setting';
const deliveryRouter: RouteRecordRaw =
  {
    path: `${roterPre}/delivery`,
    name: 'delivery',
    meta: {
      icon: '',
      title: '同城配送'
    },
    alwaysShow: true,
    component: Layout,
    children: [
      {
        path: 'store_manage',
        name: 'StoreManage',
        meta: {
          title: '门店管理'
        },
        component: () => import('@/views/cityDelivery/storeManage/index.vue')
      },
      {
        path: 'usage_record',
        name: 'UsageRecord',
        meta: {
          title: '使用记录'
        },
        component: () => import('@/views/cityDelivery/usageRecord/index.vue')
      },
      {
        path: 'recharge_record',
        name: 'RechargeRecord',
        meta: {
          title: '充值记录'
        },
        component: () => import('@/views/cityDelivery/rechargeRecord/index.vue')
      },
      {
        path: 'personnel_review',
        name: 'PersonnelReview',
        meta: {
          title: '配送员审核'
        },
        component: () => import('@/views/cityDelivery/personnelReview/index.vue')
      }
    ]
  }

export default deliveryRouter;
